import {inject, Injectable} from '@angular/core';
import {DirectusTranslation, ModuleFunction} from '@frontend/directus';
import {TranslocoService} from '@jsverse/transloco';
import {ModuleFunctionDisplayData} from '../models/module-function-display.model';

@Injectable({
  providedIn: 'root',
})
export class FunctionDisplayService {
  private readonly translocoService = inject(TranslocoService);

  private getTranslatedName(
    item: {name: string; translations?: DirectusTranslation[]},
    fallback: string,
  ): string {
    const currentLang = this.translocoService.getActiveLang();
    const translation = item.translations?.find((t) => t.language === currentLang);
    return translation?.name ?? item.name ?? fallback;
  }

  groupFunctionsByModule(
    functions: ModuleFunction[],
  ): Map<string, {count: number; names: string[]}> {
    const moduleFunctionMap: Map<string, {count: number; names: string[]}> = new Map();

    functions.forEach((func) => {
      if (func.module_id?.name && func.name) {
        const moduleName = this.getTranslatedName(func.module_id, 'Unknown Module');
        const functionName = this.getTranslatedName(func, 'Unknown Function');

        const existing = moduleFunctionMap.get(moduleName);
        if (existing) {
          existing.count++;
          existing.names.push(functionName);
        } else {
          moduleFunctionMap.set(moduleName, {count: 1, names: [functionName]});
        }
      }
    });

    return moduleFunctionMap;
  }

  displayAsModuleNameWithFunctionsCount(
    moduleFunctionMap: Map<string, {count: number; names: string[]}>,
  ): ModuleFunctionDisplayData[] {
    return Array.from(moduleFunctionMap.entries()).map(([moduleName, value]) => ({
      moduleName,
      count: value.count,
      functionNames: value.names,
    }));
  }
}
